export default __webpack_public_path__ + "static/media/up.a13603d3.svg";